import { z } from 'zod';
import { api } from './api';
import { periodSchema, type Period } from '@/types/schemas';

export const periodsService = {
  list: (signal?: AbortSignal): Promise<Period[]> =>
    api.get('/periods', z.array(periodSchema), signal),

  close: (periodId: string, note?: string): Promise<Period> =>
    api.post(`/periods/${periodId}/close`, periodSchema, { note: note ?? null }),

  /** Reason is mandatory — the server rejects an empty one with 422. */
  reopen: (periodId: string, reason: string): Promise<Period> =>
    api.post(`/periods/${periodId}/reopen`, periodSchema, { reason }),
};
